import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import ENUMS from '../../../enums';
import * as ticketsActions from '../../../redux/tickets/actions';
import Spin from '../../../components/loading';
import ShowForPermission from '../../../components/ShowForPermission';
import { enumHelper } from '../../../utils';
import Pagination2 from '../../../components/Pagination2';

class TicketsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketOpen: false,
      selectedTicketId: null,
      status: '',
      currentPage: 1,
      itemsPerPage: 10,
      isActive: false,
    };
  }

  renderStatusColors = status => {
    switch (status) {
      case 'PENDING':
        return 'text-warning';
      case 'RESPONDED':
        return 'text-success';
      case 'CLINET_RESPONSE':
        return 'text-info';
      case 'CLOSED':
        return 'text-muted';
      default:
        return 'text-dark';
    }
  };

  componentDidMount() {
    this.props.fetchAllUserTickets(
      `pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`,
    );
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      console.log('pageNumber is: ', pageNumber);
      console.log('pageSize is: ', pageSize);
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;

    console.log('pagination data: ', data);

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllUserTickets(query);
    });
  };

  render() {
    let {
      ticketsList = [],
      ticketsLoading,
      ticketsMessage,
      ticketsError,
      ticketsFailed,
      tickets,
    } = this.props;
    let {
      totalRecords, pageNumber, pageSize,
    } = tickets;
    let { itemsPerPage } = this.state;
    return (
      <>
        <Spin spinning={ticketsLoading}>
          {ticketsError && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
          {ticketsFailed && <div className="alert alert-danger">{ticketsMessage}</div>}
          <table className="table table-hover table-light table-striped">
            <thead>
            <tr>
              <th className="text-center">{locales('tables.row')}</th>
              <th className="text-center">{locales('tables.title')}</th>
              <th className="text-center ">{locales('tables.creator')}</th>
              <th className="text-center">{locales('tables.lastUpdate')}</th>
              <th className="text-center">{locales('tables.status')}</th>
              <th className="text-center"></th>
            </tr>
            </thead>
            <tbody>
            {ticketsList.length ? (
              ticketsList.map((ticket, index) => (
                <tr key={ticket.id}>
                  <td className="text-center">{(pageNumber) * pageSize + index + 1}</td>
                  <td title={ticket.title} className="text-center">
                    {ticket.title}
                  </td>
                  <td className="text-center">{ticket.createdFullName}</td>
                  <td className={`text-center`}>{ticket.lastUpdatedAt}</td>
                  <td className={`text-center ${this.renderStatusColors(ticket.status)}`}>
                    {enumHelper.convertEnumValueToTitle(ENUMS.TICKETS_STATUS.list, ticket.status)}
                  </td>
                  <td className={`text-center`}>
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_TICKET_DETAILS}>
                      <NavLink
                        to={{
                          pathname: '/ticket/details',
                          ticketId: ticket.id,
                        }}
                      >
                        <i
                          title={locales('titles.ticketDetails')}
                          className="text-center far fa-info-circle text-success pointer"
                        />
                      </NavLink>
                    </ShowForPermission>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="col-12 text-center">
                <td className="alert alert-info" colSpan={12}>
                  {locales('alerts.noRecord')}
                </td>
              </tr>
            )}
            </tbody>
          </table>
          <footer className="col-12 d-flex justify-content-center py-2">
            <div className="pagination-container">
              <Pagination2
                totalRecords={totalRecords || 0}
                pageLimit={itemsPerPage}
                pageNeighbours={2}
                onPageChanged={this.onPageChanged}
                currentPage={this.state.currentPage}
              />
            </div>
          </footer>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    ticketsList: state.ticketsReducer.userTicketsList,
    tickets: state.ticketsReducer.userTickets,
    ticketsFailed: state.ticketsReducer.userTicketsFailed,
    ticketsError: state.ticketsReducer.userTicketsError,
    ticketsMessage: state.ticketsReducer.userTicketsMessage,
    ticketsLoading: state.ticketsReducer.userTicketsLoading,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchAllUserTickets: query => dispatch(ticketsActions.fetchAllUserTickets(props.userId, query)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TicketsTable));
